import { useLoginInfo } from 'hooks/useLoginInfo';
import { IfPartnerUser } from 'models/partner/IfPartnerUser';
import useSWR from 'swr';
import { nulllist } from 'util/ssqutil';

export const useApiPartnerUserList = (): { list: IfPartnerUser[] } => {
  const loginInfo = useLoginInfo();
  const { data } = useSWR<IfPartnerUser[]>(
    loginInfo?.userId && ['/api/guest/zdata/partneruser/list', { userId: loginInfo.userId }]
  );
  return { list: data || nulllist };
};
